import { render, staticRenderFns } from "./disposalResultReview.vue?vue&type=template&id=6d491262&scoped=true"
import script from "./disposalResultReview.vue?vue&type=script&lang=js"
export * from "./disposalResultReview.vue?vue&type=script&lang=js"
import style0 from "./disposalResultReview.vue?vue&type=style&index=0&id=6d491262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d491262",
  null
  
)

export default component.exports